import { PropTypes } from 'react';
import contextTypes from './contextTypes';

export default Object.assign({}, contextTypes, { header: PropTypes.bool });



// WEBPACK FOOTER //
// ./src/js/DataTables/headerContextTypes.js